export const MAX_ACTIVE_ATTACHMENTS_COUNT = 5;
export const NO_DATA_AVAILABLE = 'No data available';
